jQuery(document).ready(function ($) {
    if ($('#scroll-gallery').length) {
        $(window).on('scroll', function () {
            if (window.innerWidth >= 992) {
                var scrollTop = $(window).scrollTop();
                var sectionTop = $('#scroll-gallery').offset().top;
                var sectionHeight = $('#scroll-gallery').outerHeight();
                var windowHeight = $(window).height();

                // Only animate if section is near/in viewport
                if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
                    var progress = (scrollTop + windowHeight - sectionTop) / (windowHeight + sectionHeight);
                    
                    // Center the translations and apply different parallax speed factors
                    var shift1 = (progress - 0.5) * -100;
                    var shift2 = (progress - 0.5) * -220;
                    var shift3 = (progress - 0.5) * -150;
                    var shift4 = (progress - 0.5) * -280;

                    $('.gallery-col:nth-child(1)').css('transform', 'translateY(' + shift1 + 'px)');
                    $('.gallery-col:nth-child(2)').css('transform', 'translateY(' + shift2 + 'px)');
                    $('.gallery-col:nth-child(3)').css('transform', 'translateY(' + shift3 + 'px)');
                    $('.gallery-col:nth-child(4)').css('transform', 'translateY(' + shift4 + 'px)');
                }
            } else {
                $('.gallery-col').css('transform', 'none');
            }
        });
    }

    // Hero CTA Panel slider toggle
    if ($('.hero-cta-toggle-btn').length) {
        $('.hero-cta-toggle-btn').on('click', function(e) {
            e.preventDefault();
            var wrapper = $('.hero-cta-slider-wrapper');
            wrapper.toggleClass('closed');
            
            if (wrapper.hasClass('closed')) {
                // Change icon to Chevron Arrow (pointing left)
                wrapper.find('.svg-close').addClass('d-none');
                wrapper.find('.svg-arrow').removeClass('d-none');
            } else {
                // Change icon to Close (X)
                wrapper.find('.svg-arrow').addClass('d-none');
                wrapper.find('.svg-close').removeClass('d-none');
            }
        });
    }

    // Curated Slider Section
    if ($('.images-carousel').length) {
        $('.images-carousel').slick({
            slidesToShow: 1.3,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.1
                    }
                }
            ]
        });

        // Sync arrow clicks
        $('.slider-navigation .prev-arrow').on('click', function() {
            $('.images-carousel').slick('slickPrev');
        });
        $('.slider-navigation .next-arrow').on('click', function() {
            $('.images-carousel').slick('slickNext');
        });

        // Sync text items
        $('.images-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.slide-text-item').removeClass('active');
            $('.slide-text-item[data-index="' + nextSlide + '"]').addClass('active');
        });
    }
});
